import { render, staticRenderFns } from "./ProjectType.vue?vue&type=template&id=366d50d4&scoped=true"
import script from "./ProjectType.vue?vue&type=script&lang=js"
export * from "./ProjectType.vue?vue&type=script&lang=js"
import style0 from "./ProjectType.vue?vue&type=style&index=0&id=366d50d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "366d50d4",
  null
  
)

export default component.exports